<div class="box">
  <div class="modal-header">
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <img
      class="mx-auto mt-4"
      width="80"
      height="80"
      src="assets/img/icons/appointment.svg"
      alt="appointment"
    />

    <div>
      <div class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.NAVIGATE_MODAL.DEPARTURE_CREATED'
            | translate
        }}
      </div>

      <div class="modal-sub-title text-center">
        {{
          'BATCH_MAILING.BATCHES_TAB.NAVIGATE_MODAL.NEED_TO_ADD_ATTACHMENTS'
            | translate
        }}
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="button button--outlined"
      (click)="hide('decline')"
    >
      {{ 'LATER' | translate }}
    </button>

    <button
      type="button"
      class="button button--filled button--shadow"
      (click)="hide('confirm')"
    >
      {{ 'ADD' | translate }}
    </button>
  </div>
</div>
